import * as THREE from 'three'
import settings from './config/Settings'

class Camera {
  constructor() {
    this.three = {
      camera: this.createCamera(),
    }
  }

  createCamera() {
    var camera = new THREE.PerspectiveCamera(...settings.cameraSettings)
    camera.position.setFromSpherical(new THREE.Spherical(...settings.cameraPosition))
    camera.lookAt(new THREE.Vector3(0, 0, 0))
    return camera
  }

  getPosition() {
    return this.three.camera.position
  }

  setAspectRatio(width, height) {
    this.three.camera.aspect = width / height
  }

  updateProjectionMatrix() {
    this.three.camera.updateProjectionMatrix()
  }

  distanceTo(position) {
    return this.three.camera.position.distanceTo(position)
  }

  setNearPlane(distance) {
    this.three.camera.near = distance
  }
}

export default Camera;